import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetDateWeeksString,GetChildrenInfoForList,GetChildrenStudyStatus, isObjEmpty } from "../../../components/common/Common";
import closeIcon from "../../../img/icon/icon-list-arrow-01.svg";
import openIcon from "../../../img/icon/icon-list-arrow-02.svg";

const ClassStudyInformation = ({varClassStudyType,varClassStudyIndex,varClassStudyInfo,onShowStudyInfoHandler}) => {
  const navigate = useNavigate();
  const [varChildrenNormalList,setChildrenNormalList] = useState([]);
  const [varChildrenReinForceList,setChildrenReinForceList] = useState([]);
  /* const [varChildrenParticipateList,setChildrenParticipateList] = useState([]); */

  //최초실행부
  useEffect(() => {
    if(!isObjEmpty(varClassStudyInfo) && varClassStudyInfo.childrens.length > 0) {
      const childrenList = varClassStudyInfo.childrens;

      //정규수업
      const normalList = childrenList.filter(el=>el.csc_mode === 0);
      setChildrenNormalList(normalList);
      //보강수업
      const reinForceList = childrenList.filter(el=>el.csc_mode === 1);
      setChildrenReinForceList(reinForceList);
      //참여수업
      /* const participateList = childrenList.filter(el=>el.csc_mode === 2);
      setChildrenParticipateList(participateList); */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGotoChildrenPageHandler = (e,datas) => {
    navigate(`/Branch/ChildrenInformation/${datas.ch_idx}/${datas.csc_cl_idx}`);
  }

  return isObjEmpty(varClassStudyInfo)?null:(
    <>
      <div className="list-head" onClick={e=>onShowStudyInfoHandler(e,varClassStudyInfo.cs_idx)}>
        <img src={varClassStudyInfo.cs_idx===varClassStudyIndex?openIcon:closeIcon} alt=""/>
        <p>{varClassStudyInfo.cs_index}차 수업</p>
        <div>{GetDateWeeksString(varClassStudyInfo.cs_date)} {varClassStudyInfo.cs_hour}:{varClassStudyInfo.cs_minute}</div>
      </div>
      <div className="list-body">
        {varClassStudyType>0?null:
          <div className="bd-con">
            <p className="con-tit">정규 수업</p>
            <ul>
              {varChildrenNormalList.map((normal,i1)=>(
                <li key={'normal_'+i1} className={GetChildrenStudyStatus(normal)===1?"":"state02"} onClick={e=>onGotoChildrenPageHandler(e,normal)}>{GetChildrenInfoForList(normal,1)}</li>
              ))}
            </ul>
          </div>
        } 
        {varClassStudyType===2?null:
          <div className="bd-con">
            <p className="con-tit">보강 수업</p>
            <ul>
              {varChildrenReinForceList.map((reinforce,i2)=>(
                <li key={'reinforce_'+i2} className={GetChildrenStudyStatus(reinforce)===1?"":"state02"} onClick={e=>onGotoChildrenPageHandler(e,reinforce)}>{GetChildrenInfoForList(reinforce,2)}</li>
              ))}
            </ul>
          </div>
        }
        {/* {varClassStudyType===1?null:
          <div className="bd-con">
            <p className="con-tit">참여 수업</p>
            <ul>
            {varChildrenParticipateList.length === 0 ?
              <li className="no-txt">⛔ 현재 참여 수업 인원이 존재하지 않습니다.</li>
            :
              varChildrenParticipateList.map((parti,i3)=>(
                <li key={'parti_'+i3} className={GetChildrenStudyStatus(parti)===1?"":"state02"} onClick={e=>onGotoChildrenPageHandler(e,parti)}>{GetChildrenInfoForList(parti,3)}</li>
              ))
            }
            </ul>
          </div>
        } */}
      </div>
    </>
  )
}
export default ClassStudyInformation;